import { useCallback, useState } from "react";
import { useAuthenticatedFetchWithWorkspace } from "../../Keycloak/useAuthenticatedFetchWithWorkspace";

type CustomerFormsData = Record<string, Record<string, string>>;

const useUpdateFormAnswers = () => {
    const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    const updateFormAnswers = useCallback(
        async (personId: string | number, forms: CustomerFormsData): Promise<boolean> => {
            if (!isReady) return false;
            setIsLoading(true);
            setError("");
            try {
                await authFetch("/addOrUpdateDetailsFormPerson", {
                    method: "PATCH",
                    body: JSON.stringify({ personId, forms }),
                });
                return true;
            } catch (err: unknown) {
                setError(err instanceof Error ? err.message : "Erreur lors de l'enregistrement du questionnaire");
                return false;
            } finally {
                setIsLoading(false);
            }
        },
        [authFetch, isReady]
    );

    return { updateFormAnswers, isLoading, error };
};

export default useUpdateFormAnswers;
